module.exports = __webpack_public_path__ + "img/unknown.b94fa352.svg";